import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
const FontSelector: React.FC<{
  setFontFamilyName: any;
  familyName: any;
}> = ({ setFontFamilyName, familyName }) => {
  const FontFamilyArray = [
    "メイリオ",
    "けいふぉんと",
    "チェックポイント★リベンジ",
  ];
  const changeFamilyName = (event: any) => {
    setFontFamilyName(event.target.value);
  };
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="demo-simple-select-label">フォント変更</InputLabel>
      <Select onChange={changeFamilyName} value={familyName}>
        {FontFamilyArray.map((fontName, i) => (
          <MenuItem value={fontName} key={i}>
            {fontName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FontSelector;
